import React, {useContext, useEffect, useState} from 'react';
import OrgPage from "../../../components/OrgPage";
import {SystemManager_API} from "../SystemManager.API";
import LinkCell from "../../../components/Pages/TablePage/Table/Cells/LinkCell3/LinkCell3";
import {observer, useLocalObservable} from "mobx-react";
import {useAPI} from "../../../hooks/useAPI";
import {formatDate} from "../../../utils/utils";
import MainSelect from "../../../components/Selects/MainSelect/MainSelect";
import FormInput from "../../../components/Inputs/FormInput/FormInput";
import styled from "styled-components";
import ApiSearchInput from "../../../components/Organisms/APISearchInput";
import {api_activities_errors} from "../../../api/systemManager/api.activities_errors";
import NewModal from "../../../components/NewModal/NewModal";
import Modal from "../../../components/Modal";
import Form from "../../../components/Form/Form";
import CircleInput from "../../../components/Inputs/CircleInput/CircleInput";

const Editing = observer(() => {
        const {getMistakes} = SystemManager_API.activities.mistakes
        const {APIRequest} = useAPI()

        const [refresh, setRefresh] = useState(false)
        const [modal, setModal] = useState(null)

        const updateManyErrors = async (type, body) => {
            await APIRequest(api_activities_errors.updateManyErrors(type), body).then(res => res.message !== "ok" && (alert(res.message)))
            setRefresh(prev => !prev)
        }
        const updateOneError = async (mistakeId, patientId, body) => {
            return await APIRequest(api_activities_errors.updateOneErrors(mistakeId, patientId), body)
        }


        return (
            <>
                {modal ? <EditingModal setModal={setModal} sumbit={updateOneError} {...modal}/> : ""}
                <OrgPage
                    url={`${process.env.REACT_APP_BASE_URL}` + getMistakes().api}
                    refresh={refresh}
                    filterComponent={<SideBar updateManyErrors={updateManyErrors}/>}
                    exportTemplateButtons={{export: false, registry: false}}
                    filterBarButtons={{downloadTemplate: {show: false,}}}


                    breadCrumbsItems={[
                        {title: 'Активность'},
                        {title: 'Редактирование', actual: true},
                    ]}
                    firstRow={[
                        {title: 'ФИО'},
                        {title: 'Дата рождения'},
                        {title: 'Организация'},
                        {title: 'Дата прохождения'},
                        {title: 'Мед. центр'},
                    ]}
                    haveToShow={[
                        {
                            type: 'wrapperCell',
                            typeData: {
                                cell: props => <LinkCell editClick={_ => {
                                    setModal(true)
                                    setModal({
                                        medCenterId: props?.all?.medCenter?._id,
                                        organizationId: props?.all?.organization?._id,
                                        patientId: props?.all?.patient_info?._id,
                                        patientName: props?.all?.patient_info?.name,
                                        mistakeId: props?.all?._id
                                    })
                                }} linkTitle={props.all.patient_info?.fio}/>
                            }
                        },
                        {
                            type: 'wrapperCell',
                            typeData: {
                                cell: props => <LinkCell
                                    linkTitle={props.all.patient_info?.dob && formatDate(props.all.patient_info?.dob)}/>
                            }
                        },

                        {
                            type: 'wrapperCell',
                            typeData: {cell: props => <LinkCell linkTitle={props.all.organization.name}/>}
                        },
                        {
                            type: 'wrapperCell',
                            typeData: {
                                cell: props => <LinkCell
                                    linkTitle={props.all.resultDate && formatDate(props.all.resultDate)}/>
                            }
                        },
                        {
                            type: 'wrapperCell',
                            typeData: {cell: props => <LinkCell linkTitle={props?.all?.medCenter?.name}/>}
                        },

                    ]}
                />
            </>

        );
    }
)
const EditingModal = observer((props) => {

    const [errors, setErrors] = useState({})
    const store = useLocalObservable(() => ({
        state: {
            medCenterId: props.medCenterId,
            organizationId: props.organizationId,
            patientId: props.patientId,
            mistakeId: props.mistakeId,
            patientName: props.patientName
        },
        setState: (key, value) => store.state = {...store.state, [key]: value},
        prepare: () => ({organizationId: store.state.organizationId, medCenterId: store.state.medCenterId}),
        errors: {res: {message: 'adasd'}},
        setErrors: (errors) => store.state.errors = errors
    }))

    const submit = async (e) => {
        e.preventDefault()
        const state = store.state
        await props.sumbit(state.mistakeId, state.patientId, store.prepare())
            .then(res => {
                res.message === "Успешно обновлено." ? props.setModal(null) : setErrors({serverError: {message: res.message}})
            })
    }

    return (
        <Modal mobile={true}>
            <NewModal
                completed={false}
                completedButtonText={'Продолжить'}
                closeHandler={_ => props.setModal(null)}
                completedText={""}
                title={"Изменить"}
                errors={errors}
            >

                <Form
                    submitButtonText={'Изменить'}
                    submitHandler={submit}
                    submitDisabled={store.state.organizationId ? false : store.state.medCenterId ? false : true}
                >
                    <ApiSearchInput chooseHandler={id => store.setState('medCenterId', id)}
                                    maxHeight={100}
                                    initialValue={props.medCenterId} title={"Мед. центр"} orgType="medcenter"/>
                    <ApiSearchInput maxHeight={90}
                                    chooseHandler={id => store.setState('organizationId', id)}

                                    initialValue={props.organizationId} title={"Организация"}
                                    orgType="organization"/>
                </Form>
            </NewModal>
        </Modal>
    )

})
const SideBar = observer((props) => {
    const store = useLocalObservable(() => ({
        state: {
            changeFromId: '',
            changeTo: "",
            searchType: ""
        },
        setState: (key, value) => store.state = {...store.state, [key]: value},
        prepare: () => ({organizationId: store.state.changeFromId, name: store.state.changeTo})
    }))


    return <StyledSidebar>
        <div className="page__filter-sidebar__title">Редактирование</div>


        <CircleInput onChange={e => store.setState("changeTo", e.target.value)} name={"changeTo"} value={store.state}
                     placeHolder="C"/>
        <ApiSearchInput
            orgType="allOrganizations"
            placeholder="По"
            icon={"search"}
            chooseHandler={id => store.setState("changeFromId", id)}
        />

        <MainSelect
            onChange={selected => store.setState('searchType', selected.value)}
            placeholder="Вид организации"
            options={[
                {label: "Медцентр", value: "medCenter"},
                {label: "Организация", value: "organization"},
            ]}
        />


        <div className={'wrapper'}>

            <div className='button-area'>


                <div className={'confirm_area'}>
                    <button onClick={_ => props.updateManyErrors(store.state.searchType, store.prepare())}
                            className={'button'}>Применить
                    </button>


                </div>


            </div>
        </div>
    </StyledSidebar>
})

const StyledSidebar = styled.div`
  .title {

  }

  .circleInput {
    margin-bottom: 10px;
  }

  .form-input {
    border-radius: 100px;
    background: white !important;
    width: 288px;
    border: none;

    &::placeholder {
      font-weight: normal;
      color: black;
    }
  }

  .live-Search {
    width: 288px;
  }

  .live-Search__Dropdown-Helper {
    width: 288px !important;
    top: 65px;

  }

`

export default Editing;